import request from '../request';

export async function getBiJwtToken() {
  return request<API.CommonResponse<string>>({
    url: '/api/mall/rest/bi/data/wind/jwtToken/get',
    method: 'POST',
  });
}

export async function getComList() {
  return request<API.CommonResponse<API.SpuSimpleInfoVO[]>>({
    url: '/api/mall/rest/search/pg/demonstration',
    method: 'POST',
    headers: { authLogin: true },
  });
}

export async function getComSkuList(params: any) {
  return request<API.CommonResponse>({
    url: '/api/mall/rest/search/skulist',
    method: 'POST',
    headers: { authLogin: true },
    data: params,
  });
}
